import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { LinearProgress, Typography } from '@mui/material';
import { InfoCard } from '@/components/shared/info-card';
import type { Lesson } from '@/data/eduplay/interfaces';

const getProgress = (lesson: Lesson) => lesson.aula_alunos[0]?.progresso || 0;

interface LessonItemProps {
  lesson: Lesson;
  isCurrent: boolean;
  onClick: () => void;
}

export const LessonItem = ({ lesson, isCurrent, onClick }: LessonItemProps) => {
  return (
    <InfoCard
      icon={PlayCircleOutlineIcon}
      onClick={onClick}
      withBorder
      sx={(theme) => ({
        backgroundColor: isCurrent
          ? theme.palette.neutral?.[100] || theme.palette.grey[100]
          : 'transparent',
        borderRadius: 0,
      })}
    >
      <Typography
        color={isCurrent ? 'primary.dark' : 'text.primary'}
        fontWeight={isCurrent ? 'bold' : 'semibold'}
      >
        {lesson.titulo}
      </Typography>
      <Typography fontWeight="semibold">
        Progresso: {getProgress(lesson)}%
      </Typography>
      <LinearProgress
        value={getProgress(lesson)}
        variant="determinate"
        sx={{ mt: 2 }}
      />
    </InfoCard>
  );
};
